<template>
  <div class="search">
    <el-form :inline="true" :disabled="loading" label-width="82px">
      <el-form-item label="日期范围：">
        <el-date-picker
          v-model="range"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:260px;margin-left:5px;"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="goSearch">查询</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-form-item>

      <div style="float:right">
        <el-button
          type="text"
          style="margin-right:1rem;display:inline-block;"
          @click="exportExcel"
        >
          导出Excel
        </el-button>

        <el-radio-group
          style="margin-right: 10px"
          :value="type"
          @input="showChange"
        >
          <el-radio-button label="chart">
            图表
          </el-radio-button>
          <el-radio-button label="table">
            数据视图
          </el-radio-button>
        </el-radio-group>
      </div>
    </el-form>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    loading: Boolean,
    type: String
  },
  data() {
    let now = moment()
    let begin = now.startOf('quarter').format('YYYY-MM-DD')

    return {
      range: [begin, moment().add(1, 'days').format('YYYY-MM-DD')]
    }
  },
  mounted() {
    this.goSearch()
  },
  methods: {
    resetSearch() {
      this.range = []
    },
    goSearch() {
      let [b, e] = this.range
      if (b && e && !this.loading) {
        this.$emit('date-change', b, e)
      }
    },
    showChange(v) {
      this.$emit('type-change', v)
    },
    exportExcel() {
      this.$emit('export-excel')
    }
  }
}
</script>

<style lang="css" scoped>
.search {
  background-color: #fff;
  padding: 18px 20px;
  padding-bottom: 0;
  border-bottom: 1px dashed #ebeef5;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>
